<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-8 px-4 sm:px-6 lg:px-8">
  <div class="max-w-5xl mx-auto">
    
    <!-- Back Button -->
    <div class="mb-6">
      <button 
        (click)="goBack()"
        class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200">
        <i class="bi bi-arrow-left me-2"></i>
        Volver a Tiendas
      </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="flex justify-center items-center py-20">
      <div class="text-center">
        <div class="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600"></div>
        <p class="mt-4 text-gray-600 font-medium">Cargando información...</p>
      </div>
    </div>

    <!-- Shop Detail/Edit Form -->
    <div *ngIf="!loading" class="bg-white shadow-xl rounded-2xl border border-gray-200 overflow-hidden">
      
      <!-- Header -->
      <div class="px-8 py-6 border-b border-gray-200"
           [ngClass]="isNewShop ? 'bg-gradient-to-r from-blue-600 to-blue-700' : (shop?.status ? 'bg-gradient-to-r from-green-600 to-emerald-600' : 'bg-gradient-to-r from-gray-600 to-slate-600')">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-4">
            <div class="bg-white bg-opacity-20 rounded-xl p-3">
              <span class="text-4xl">🏪</span>
            </div>
            <div>
              <h1 class="text-2xl font-bold text-white">
                {{ isNewShop ? 'Nueva Tienda' : (isEditMode ? 'Editar Tienda' : shop?.name) }}
              </h1>
              <p class="text-blue-100 text-sm mt-1" *ngIf="!isNewShop">
                Código: {{ shop?.code }}
              </p>
            </div>
          </div>
          
          <!-- Action Buttons (View Mode) -->
          <div *ngIf="!isEditMode && !isNewShop" class="flex gap-2">
            <button
              (click)="enableEditMode()"
              class="inline-flex items-center px-4 py-2 border border-white text-sm font-medium rounded-lg text-white hover:bg-white hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white transition-all duration-200">
              <i class="bi bi-pencil me-2"></i>
              Editar
            </button>
            <button
              (click)="toggleShopStatus()"
              class="inline-flex items-center px-4 py-2 border border-white text-sm font-medium rounded-lg text-white hover:bg-white hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white transition-all duration-200">
              <i class="bi me-2" [ngClass]="shop?.status ? 'bi-x-circle' : 'bi-check-circle'"></i>
              {{ shop?.status ? 'Inactivar' : 'Activar' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Form Content -->
      <div class="px-8 py-6">
        <form>
          <div class="space-y-6">
            
            <!-- Código (solo para nueva tienda) -->
            <div *ngIf="isNewShop">
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <i class="bi bi-hash text-blue-600 me-1"></i>
                Código <span class="text-red-500">*</span>
              </label>
              <input 
                type="text"
                [(ngModel)]="formData.code"
                name="code"
                [disabled]="!isEditMode"
                [class.border-red-500]="errors.code"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 disabled:bg-gray-100 disabled:cursor-not-allowed"
                placeholder="Ej: 1073">
              <p *ngIf="errors.code" class="mt-1 text-sm text-red-600">{{ errors.code }}</p>
              <p class="mt-1 text-xs text-gray-500">El código debe ser único y no se podrá modificar después</p>
            </div>

            <!-- Código (vista solo lectura) -->
            <div *ngIf="!isNewShop && !isEditMode">
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <i class="bi bi-hash text-blue-600 me-1"></i>
                Código
              </label>
              <div class="px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg">
                <p class="text-gray-900 font-medium">{{ shop?.code }}</p>
              </div>
            </div>

            <!-- Nombre -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <i class="bi bi-shop text-blue-600 me-1"></i>
                Nombre <span class="text-red-500">*</span>
              </label>
              <input 
                type="text"
                [(ngModel)]="formData.name"
                name="name"
                [disabled]="!isEditMode"
                [class.border-red-500]="errors.name"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 disabled:bg-gray-100 disabled:cursor-not-allowed"
                placeholder="Ej: SUCURSAL 73 Los Palos Grandes">
              <p *ngIf="errors.name" class="mt-1 text-sm text-red-600">{{ errors.name }}</p>
            </div>

            <!-- Nombre Corto -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <i class="bi bi-tag text-blue-600 me-1"></i>
                Nombre Corto <span class="text-red-600">*</span>
              </label>
              <input 
                type="text"
                [(ngModel)]="formData.short_name"
                name="short_name"
                maxlength="30"
                [disabled]="!isEditMode"
                [class.border-red-500]="errors.short_name"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 disabled:bg-gray-100 disabled:cursor-not-allowed"
                placeholder="Ej: Los Palos Grandes">
              <p *ngIf="errors.short_name" class="mt-1 text-sm text-red-600">{{ errors.short_name }}</p>
            </div>

            <!-- Dirección -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <i class="bi bi-geo-alt text-blue-600 me-1"></i>
                Dirección
              </label>
              <textarea 
                [(ngModel)]="formData.address"
                name="address"
                [disabled]="!isEditMode"
                rows="3"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 disabled:bg-gray-100 disabled:cursor-not-allowed resize-none"
                placeholder="Ej: Av. Principal de Los Palos Grandes"></textarea>
            </div>

            <!-- Descripción -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <i class="bi bi-info-circle text-blue-600 me-1"></i>
                Descripción
              </label>
              <textarea 
                [(ngModel)]="formData.description"
                name="description"
                [disabled]="!isEditMode"
                rows="3"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 disabled:bg-gray-100 disabled:cursor-not-allowed resize-none"
                placeholder="Descripción de la tienda"></textarea>
            </div>

            <!-- Opciones (Checkboxes) -->
            <div class="border-t border-gray-200 pt-6">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">Configuración</h3>
              
              <div class="space-y-4">
                <!-- Registro de Clientes -->
                <div class="flex items-start">
                  <div class="flex items-center h-5">
                    <input 
                      type="checkbox"
                      [(ngModel)]="formData.register_clients"
                      name="register_clients"
                      [disabled]="!isEditMode"
                      class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 disabled:cursor-not-allowed">
                  </div>
                  <div class="ml-3">
                    <label class="font-medium text-gray-700 flex items-center gap-2">
                      <i class="bi bi-person-plus text-purple-600"></i>
                      Registro de Clientes
                    </label>
                    <p class="text-sm text-gray-500">Permite el registro de nuevos clientes en esta tienda</p>
                  </div>
                </div>

                <!-- Compras Disponibles -->
                <div class="flex items-start">
                  <div class="flex items-center h-5">
                    <input 
                      type="checkbox"
                      [(ngModel)]="formData.available_purchases"
                      name="available_purchases"
                      [disabled]="!isEditMode"
                      class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 disabled:cursor-not-allowed">
                  </div>
                  <div class="ml-3">
                    <label class="font-medium text-gray-700 flex items-center gap-2">
                      <i class="bi bi-cart-check text-amber-600"></i>
                      Compras Disponibles
                    </label>
                    <p class="text-sm text-gray-500">Habilita la realización de compras en esta tienda</p>
                  </div>
                </div>

                <!-- Visibilidad -->
                <div class="flex items-start">
                  <div class="flex items-center h-5">
                    <input 
                      type="checkbox"
                      [(ngModel)]="formData.visibility"
                      name="visibility"
                      [disabled]="!isEditMode"
                      class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 disabled:cursor-not-allowed">
                  </div>
                  <div class="ml-3">
                    <label class="font-medium text-gray-700 flex items-center gap-2">
                      <i class="bi bi-eye text-blue-600"></i>
                      Visible
                    </label>
                    <p class="text-sm text-gray-500">La tienda será visible en el sistema</p>
                  </div>
                </div>

                <!-- Estado (solo en edición) -->
                <div *ngIf="!isNewShop" class="flex items-start">
                  <div class="flex items-center h-5">
                    <input 
                      type="checkbox"
                      [(ngModel)]="formData.status"
                      name="status"
                      [disabled]="!isEditMode"
                      class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 disabled:cursor-not-allowed">
                  </div>
                  <div class="ml-3">
                    <label class="font-medium text-gray-700 flex items-center gap-2">
                      <i class="bi bi-toggle-on text-green-600"></i>
                      Activa
                    </label>
                    <p class="text-sm text-gray-500">La tienda está activa y operativa</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>

      <!-- Footer Actions (Edit Mode) -->
      <div *ngIf="isEditMode" class="px-8 py-6 bg-gray-50 border-t border-gray-200">
        <div class="flex items-center justify-end gap-3">
          <button
            (click)="cancelEdit()"
            class="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200">
            <i class="bi bi-x-circle me-2"></i>
            Cancelar
          </button>
          <button
            (click)="saveShop()"
            class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg hover:shadow-xl">
            <i class="bi bi-check-circle me-2"></i>
            {{ isNewShop ? 'Crear Tienda' : 'Guardar Cambios' }}
          </button>
        </div>
      </div>

    </div>

  </div>
</div>
